import '../../styles/field.css';
import './DateTimeRangePicker.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var dateTimeRangeCSS = _7a468({defaultClassName:'_1n9xkql0-2-0-1',variantClassNames:{showError:{true:'_1n9xkql1-2-0-1'},disabled:{true:'_1n9xkql2-2-0-1'},readOnly:{true:'_1n9xkql3-2-0-1'}},defaultVariants:{},compoundVariants:[]});